module.exports = __webpack_public_path__ + "img/future4.93bb473c.png";